import { memo } from 'react'

const IconChevronDown = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M10.1906 5.23227C10.3615 5.06141 10.6384 5.06141 10.8093 5.23227C10.9801 5.40312 10.9801 5.68006 10.8093 5.85092L7.30929 9.35092C7.13844 9.52177 6.8615 9.52177 6.69064 9.35092L3.19064 5.85092C3.01979 5.68006 3.01979 5.40312 3.19064 5.23227C3.3615 5.06141 3.63844 5.06141 3.80929 5.23227L6.99997 8.42294L10.1906 5.23227Z'
        fill={fill}
      />
    </svg>
  )
}

export default memo(IconChevronDown)
